import { IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

export enum NavigationTab {
  Photos = '#photos',
  Description = '#description',
  Map = '#map',
  Author = '#author',
  ServicePlaceOverMap = '#servicePlaceOverMap',
  ServicePlaceUnderMap = '#servicePlaceUnderMap',
  ServicePlaceOverEvaluation = '#servicePlaceOverEvaluation',
  Valuation = '#valuation',
  SimilarOffers = '#similarOffers',
}

export interface IOfferCardNavigationStoreProps {
  offer?: IOfferSchema;
  isAgentAvailable?: boolean;
  isActive?: boolean;
  activeAnchor?: string;
  isSimilarOffersAvailable?: boolean;
}

export interface IOfferCardNavigationDispatchProps {
  toggleNavigation?(isActive: boolean): void;

  changeNavigationAnchor?(activeAnchor: string): void;
}

export interface IProps {
  isFixed?: boolean;
  showRightContent?: boolean;
}

export type IOfferCardNavigationProps = IOfferCardNavigationStoreProps & IOfferCardNavigationDispatchProps & IProps;
